import { zodContractItemSchema } from '../validations';

/**
 * Validation schemas for the single contract item API call.
 * The detail response is one full contract item, identical in shape to the
 * entries of the paginated items list.
 */
export const zodContractItemDetailResponseSchema = zodContractItemSchema;
